<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_form_label_search') ||
                  '订单编号/联系人/电话/邮编/地址 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="175px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_orderStatus') || '单据状态'">
              <el-checkbox-group v-model="form.orderStatus">
                <el-checkbox label="10">{{
                  $l('form_label_orderStatus_new') || '新建'
                }}</el-checkbox>
                <el-checkbox label="11">{{
                  $l('form_label_orderStatus_submit') || '已确认'
                }}</el-checkbox>
                <el-checkbox label="12">{{
                  $l('form_label_orderStatus_shipped') || '已发运'
                }}</el-checkbox>
                <el-checkbox label="13">{{
                  $l('form_label_orderStatus_arrived') || '已送达'
                }}</el-checkbox>
                <el-checkbox label="14">{{
                  $l('form_label_orderStatus_cancelled') || '已取消'
                }}</el-checkbox>
                <el-checkbox label="15">{{
                  $l('form_label_orderStatus_refunded') || '已退款'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderNo') || '订单编号'">
              <el-input
                v-model.trim="form.orderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_customerOrderNo') || '客户订单编号'"
            >
              <el-input
                v-model.trim="form.customerOrderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_contact_name') || '联系人'">
              <el-input
                v-model.trim="form.contact"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_phone') || '联系电话'">
              <el-input
                v-model.trim="form.phone"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_address') || '收货地址'">
              <el-input
                v-model.trim="form.address"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_postalCode') || '邮编'">
              <el-input
                v-model.trim="form.postalCode"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amount') || '订单金额'">
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :precision="2"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.amountStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="0.01"
                    :precision="2"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.amountEnd"
                  ></el-input-number>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_orderDate') || '下单时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.orderStartDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="orderStartDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.orderEndDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="orderEndDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_estimatedShipDate') || '预计发货日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.estimatedShipStartDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="estimatedShipStartDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.estimatedShipEndDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="estimatedShipEndDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('form_label_estimatedDeliveryDate') || '预计到货日期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.estimatedDeliveryStartDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="estimatedDeliveryStartDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.estimatedDeliveryEndDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="estimatedDeliveryEndDatePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  orderStatus: ['10', '11', '13', '12'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      //申请日期限制
      orderStartDatePicker: this.orderEndDate(),
      orderEndDatePicker: this.orderStartDate(),
      estimatedShipStartDatePicker: this.estimatedShipEndDateDate(),
      estimatedShipEndDatePicker: this.estimatedShipStartDate(),

      estimatedDeliveryStartDatePicker: this.estimatedDeliveryEndDate(),
      estimatedDeliveryEndDatePicker: this.estimatedDeliveryStartDate(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 提交时间限制
    estimatedShipEndDateDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.estimatedShipEndDateDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.estimatedShipEndDateDate).getTime() <
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    estimatedShipStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.estimatedShipStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.estimatedShipStartDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    estimatedDeliveryEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.estimatedDeliveryEndDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.estimatedDeliveryEndDate).getTime() <
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    estimatedDeliveryStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.estimatedDeliveryStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.estimatedDeliveryStartDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    orderEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.orderEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.orderEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    orderStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.orderStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.orderStartDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
